import { Receipt, Info } from "lucide-react";
import { eur, pricingFor, KIND } from "@/lib/format";

export function QuoteCard({ form, config }) {
  if (!config) return null;
  const p = pricingFor(config, form.kind, form.equipment_type);
  const fraction = config.billing_fraction_minutes;
  const eq = config.equipment.find((e) => e.key === form.equipment_type);
  return (
    <div className="rounded-2xl border bg-white p-6 shadow-sm" data-testid="quote-card">
      <div className="flex items-center gap-2 text-[#61a229]">
        <Receipt className="h-4 w-4" />
        <p className="text-[11px] font-mono uppercase tracking-[0.2em]">Costi del servizio</p>
      </div>
      <p className="mt-3 font-display text-lg font-semibold text-slate-900">
        {KIND[form.kind]}{form.kind !== "sopralluogo" && eq ? ` · ${eq.label}` : ""}
      </p>
      <div className="mt-5 flex items-end justify-between border-b pb-4">
        <span className="text-sm font-semibold">Diritto di chiamata</span>
        <span className="font-display text-3xl font-bold text-slate-900" data-testid="quote-call-fee">{eur(p.call_fee)}</span>
      </div>
      {p.hourly_rate > 0 && (
        <div className="mt-3 flex justify-between text-sm">
          <span className="text-slate-500">Manodopera, per ora o frazione di {fraction} min</span>
          <span className="font-mono" data-testid="quote-hourly-rate">{eur(p.hourly_rate)}/h</span>
        </div>
      )}
      <p className="mt-1 text-right text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-testid="quote-vat-note">Prezzi IVA esclusa</p>
      <div className="mt-4 flex gap-2 rounded-xl bg-[#f3f8ec] p-3 text-xs leading-relaxed text-slate-600" data-testid="quote-info">
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-[#61a229]" />
        <p>
          Il diritto di chiamata copre l'uscita del tecnico ed è sempre dovuto, anche se l'intervento non viene eseguito.
          Il costo complessivo non è stimabile in anticipo: dipende dal tempo effettivamente impiegato, calcolato al costo
          per ora o frazione di ora a seconda dell'apparecchiatura oggetto di intervento ed eventuali ricambi necessari.
          Tutto viene riportato nel rapporto di intervento.
        </p>
      </div>
    </div>
  );
}
